export enum UserActivityPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    /**
     * 参与者设置
     */
    ParticipantSchemes = 'ParticipantSchemes',
    /**
     * 参与者选项
     */
    ParticipantOptions = 'ParticipantOptions',
    /**
     * 审批项
     */
    ApprovalItems = 'ApprovalItems',
    /**
     * 分配策略
     */
    AssignStrategy = 'AssignStrategy',
    /**
     * 指派规则
     */
    OperatorConfig = 'OperatorConfig',
    /**
     * 完成策略
     */
    CompleteStrategy = 'CompleteStrategy',
    /**
     * 会签规则
     */
    SignRule = 'SignRule',
    /**
     * 多实例设置
     */
    MultiInstanceLoopCharacteristics = 'MultiInstanceLoopCharacteristics',
    /**
     * 允许取回
     */
    Retrievable = 'Retrievable',
    /**
     * 允许征询
     */
    AddSignFrontAble = 'AddSignFrontAble',
    /**
     * 允许加签
     */
    AddSignBehindAble = 'AddSignBehindAble',
    /**
     * 允许知会
     */
    NotifyAble = 'NotifyAble',
    /**
     * 表单定义
     */
    ExecuteForms = 'ExecuteForms',
    /**
     * 是否允许选择目标节点
     */
    SelectTargetAble = 'SelectTargetAble',
    /**
     * 跳转范围
     */
    JumpScope = 'JumpScope',
    /**
     * 驳回规则
     */
    BackWardRule = 'BackWardRule',
    /**
     * 活动构件
     */
    Tools = 'Tools',
    /**
     * 选择后续分支
     */
    SelectBranch = 'SelectBranch',
    /**
     * 活动标题
     */
    wf_TitleExpression = 'wf_TitleExpression',
    /**
     * 默认分支
     */
    Default = 'Default',
    /**
     * 移交范围
     */
    transferScope = 'transferScope',
    /**
     * 隐藏web端待办任务
     */
    DisplayTerminal = 'DisplayTerminal',
    timeLimitControl = 'timeLimitControl',
    anonymousSet = 'anonymousSet',
    variableSettings = 'variableSettings',
    messageNotice = 'messageNotice',
    wf_ExecuteForms_PC = 'wf_ExecuteForms_PC',
    wf_ExecuteForms_Mobile = 'wf_ExecuteForms_Mobile',
    /**
     * 审批要点
     */
    approvalPivotConfig = 'approvalPivotConfig',
    urgeHandleRule = 'urgeHandleRule',
    /**
     * 影像设置
     */
    imageSettings = 'imageSettings',
    checkConditions = 'checkConditions',
    AssignPerformer = 'AssignPerformer',
    wf_CustomizeAction = 'wf_CustomizeAction',
    otherAssignNodes = 'otherAssignNodes',
    otherAssignActivities = 'otherAssignActivities',
    otherAssignActivityNodeInfos = 'OtherAssignActivityNodeInfos',
    ConditionExpression = "ConditionExpression",
    sendBackedTask = "sendBackedTask",
    BizActivityID = "BizActivityID"
}